import { render, staticRenderFns } from "./zhPrivacy.vue?vue&type=template&id=7973dc73&scoped=true&"
import script from "./zhPrivacy.vue?vue&type=script&lang=js&"
export * from "./zhPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./zhPrivacy.vue?vue&type=style&index=0&id=7973dc73&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973dc73",
  null
  
)

export default component.exports